import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@syneto/compass-react';
import {
	NO_ADDRESSES_MESSAGE,
	RECIPIENTS_LOADING_MESSAGE,
	RECIPIENTS_STATUS
} from '../../../../../../helpers/partnerPreviewRecipients';

/*
 * Says why there is no list to pick from: loading, failed (with Retry) or an empty company. It is always
 * rendered while Notify customer is checked, and the live region is always the same element, so a screen
 * reader hears each change of its text. Everything shown comes from the props. Retry is disabled while the
 * retried request loads; keyboard focus is not managed here (it is left to the modal's own focus handling).
 */
const PartnerPreviewRecipientsStatus = ({ status, error, isRetrying, onRetry }) => {
	const isLoading = status === RECIPIENTS_STATUS.LOADING;
	const showRetry = status === RECIPIENTS_STATUS.FAILED || isRetrying;

	return (
		<div className="mt-2 ms-4" role="status" aria-live="polite">
			{isLoading && <span className="text-muted">{RECIPIENTS_LOADING_MESSAGE}</span>}
			{status === RECIPIENTS_STATUS.FAILED && <span className="text-danger">{error}</span>}
			{status === RECIPIENTS_STATUS.EMPTY && <span className="text-muted">{NO_ADDRESSES_MESSAGE}</span>}
			{showRetry && <Button role="tertiary" onClick={onRetry} disabled={isRetrying}>Retry</Button>}
		</div>
	);
};

export default PartnerPreviewRecipientsStatus;

PartnerPreviewRecipientsStatus.propTypes = {
	status: PropTypes.oneOf(Object.values(RECIPIENTS_STATUS)).isRequired,
	error: PropTypes.string,
	isRetrying: PropTypes.bool,
	onRetry: PropTypes.func.isRequired
};
